import { Component, OnDestroy, OnInit } from '@angular/core';
import { APIService } from 'src/app/services/APIService';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { AuthService } from 'src/app/services/auth.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessagesService } from 'src/app/services/messages.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { PopupComponent } from 'src/app/commons/components/popup/popup.component';

@Component({
  selector: 'app-change-password',
  imports: [FormsModule, TranslateModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  standalone: true
})
export class ChangePasswordComponent extends APIService implements OnDestroy {

  constructor(public localService: LocalUtilService,
    public authService: AuthService,
    public organizationService: OrganizationService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    public dashboardService: DashboardService,
    location: Location,
    router: Router,
    public route: ActivatedRoute,
    public commonService: CommonService,
    translateService: TranslateService) {
      super(localService, location, router, translateService);
  }

  private subscriptions: Subscription[] = [];
  password: string = '';
  confirmPassword: string = '';
  
  submitChangePassword() {
    try {
      let ticketKey = new URLSearchParams(window.location.search).get("ticketKey");        
      
      // VALIDAZIONI
      if (!this.password || !this.confirmPassword) {
        this.localUtil.showError("E:CHANGE_PWD_ERR", this.ConstantsModule.ERROR_TITLE, this.messageService.getLabelFromCode("ERROR_AZ_OP_CREATE_PASSWORD_NOT_EQUAL"));
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.localUtil.showError("E:CHANGE_PWD_ERR", this.ConstantsModule.ERROR_TITLE, this.messageService.getLabelFromCode("ERROR_AZ_OP_CREATE_PASSWORD_NOT_EQUAL"));
        return;
      }

      if (this.password.trim().length < 6 || this.confirmPassword.trim().length < 6) {
        //ERROR_AZ_OP_CREATE_PASSWORD_LENGTH
        this.localUtil.showError("E:CHANGE_PWD_ERR", this.ConstantsModule.ERROR_TITLE, this.messageService.getLabelFromCode("ERROR_AZ_OP_CREATE_PASSWORD_LENGTH"));
        return;
      }

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'cache-control': 'no-cache'
      });

      // INVIA RICHIESTA
      const requestData = {
        newPassword: this.password,
        confirmNewPassword: this.confirmPassword,
        ticketKey: ticketKey
      };

      const service = this.authService.changePassword(requestData).subscribe(dt => {
        
        let params: any[] = [''];
        const modalRef = this.modalService.open(PopupComponent);
        modalRef.componentInstance.tipo='message';
        modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("INFO_TITLE");
        modalRef.componentInstance.messaggio = this.checkAndReplaceTranslation(this.translateService, this.messageService.getLabelFromCode("SUCCESS_PASSWORD_CHANGE", params));
        const service = modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
          this.router.navigate(['login']);
          this.subscriptions.push(service);      
        }, this.handleError(true));
      }, this.handleError(true));
      this.subscriptions.push(service);

    } catch (err) {
      this.localUtil.showMessage("", this.ConstantsModule.INFO_TITLE, this.checkAndReplaceTranslation(this.translateService, this.messageService.getMessageFromCode("E:GENERIC")), true);
    }
  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
                
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
  }

}
